// import axios from 'axios'
import { showSuccess, showError } from '../../index.js'

export default {
  namespaced: true,
  state () {
    return {
      document: [],
      documentCategories: [],
      docCategoriesByPerm: [],
      docByCategory: []
    }
  },
  getters: {
    backendDocumentCategories (state) {
      return state.documentCategories
    },
    backendDocument (state) {
      return state.document
    },
    frontendDocCategories (state, getters, rootState) {
      return state.docCategoriesByPerm.filter(item => item.lang === rootState.lang)
    },
    selectDocumentCategory: (state) => (lang) => {
      const data = state.documentCategories
        .filter(item => item.lang === lang && item.isHidden === false)
        .map(item => ({ id: item.id, name: item.name }))
      return data
    },
    selectDocumentCategoryFilter (state) {
      const data = state.documentCategories
        .map(item => ({ id: item.id, name: item.name }))
      return data
    },
    showDocumentCategory: (state) => (id) => {
      const data = state.documentCategories
        .find(item => item.id === id)
      return data.name
    },
    getDocumentId: (state) => (path) => {
      const data = state.document.find(item => item.filePath === path)
      return data.id
    },
    // front-end
    getDocsByCategories (state) {
      return state.docByCategory
    },
    // getDocumentsByCategory: (state) => (id) => {
    //   console.log('hii')
    //   const data = state.docByCategory.filter(item => item.categoryId === id)
    //   return data
    // },
    finalDocumentCategories (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        const data = state.documentCategories.filter(item => item.lang === 'vn')
        return data
      } else {
        const data = state.documentCategories.filter(item => item.lang === 'en')
        return data
      }
    },
    finalDocuments (state, getters, rootState) {
      if (rootState.lang === 'vn') {
        const data = state.document.filter(item => item.lang === 'vn')
        return data
      } else {
        const data = state.document.filter(item => item.lang === 'en')
        return data
      }
    },
    selectDocumentCategoryFilterFrontEnd (state, getters, rootState) {
      // eslint-disable-next-line
      let permissions = rootState.userPermissionNames.filter(item => item.toLowerCase().includes('docs'))
      console.log(permissions)

      if (permissions.length !== 0) {
        permissions.unshift('Public')
        const filteredCategories = permissions.reduce((acc, perm) => {
          const filtered = state.documentCategories.filter(item => item.permission === perm && item.lang === rootState.lang && item.isHidden === false)
          return acc.concat(filtered)
        }, [])

        return filteredCategories.map(item => ({ id: item.id, name: item.name }))
      } else {
        return state.documentCategories
          .filter(item => item.lang === rootState.lang && item.permission === 'Public' && item.isHidden === false)
          .map(item => ({ id: item.id, name: item.name }))
      }
    }
  },
  mutations: {
    setDocumentCategories (state, payload) {
      state.documentCategories = payload
    },
    setDocument (state, payload) {
      state.document = payload
    },
    setDocCategoriesByPerm (state, payload) {
      state.docCategoriesByPerm = payload
    },
    setDocByCategory (state, payload) {
      state.docByCategory = payload
    }
  },
  actions: {
    async getDocumentCategoriesData (context) {
      // await axios.get(context.rootState.API_Url + 'DocumentCategories/')
      await context.rootState.authAxios.get('/DocumentCategories').then((response) => {
        const responseData = response.data
        context.commit('setDocumentCategories', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    async getDocCategoriesDataByPerm (context) {
      try {
        if (context.rootState.authAxios === null) {
          await context.dispatch('initializeAxios', context.rootState.token, { root: true })
        }
        const response = await context.rootState.authAxios.get('/DocumentCategories/categories-by-perms')
        const category = response.data.map(item => item.id)
        context.commit('setDocCategoriesByPerm', response.data)
        return category
      } catch (error) {
        console.error('There was an error!', error)
      }
    },
    async postDocumentCategories (context, payload) {
      await context.rootState.authAxios.post('/DocumentCategories/', payload)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateDocumentCategories (context, payload) {
      await context.rootState.authAxios.put(`/DocumentCategories/${payload.id}`, payload)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteDocumentCategories (context, payload) {
      await context.rootState.authAxios.delete(`/DocumentCategories/${payload}`)
        .then(() => {
          showSuccess('Xóa thành công')
        }).catch((error) => {
          if (error.response.data.error_message) {
            showError(error.response.data.error_message)
          } else {
            showError('Đã xảy ra lỗi không mong muốn')
          }
        })
    },
    // Document
    async getDocumentData (context) {
      // await axios.get(context.rootState.API_Url + 'Documents/')
      await context.rootState.authAxios.get('/Documents').then((response) => {
        const responseData = response.data
        context.commit('setDocument', responseData)
      }).catch((error) => {
        console.error('There was an error!', error)
      })
    },
    // async getDocumentFrontend (context, payload) {
    //   const ids = payload.join(',')
    //   await axios.get(context.rootState.API_Url + `Documents/${ids}`).then((response) => {
    //     const responseData = response.data
    //     context.commit('setDocByCategory', responseData)
    //   }).catch((error) => {
    //     console.error('There was an error!', error)
    //   })
    // },
    async postDocument (context, payload) {
      const formData = new FormData()

      if (!payload.fileName) {
        payload.fileName = payload.file.name.split('.').slice(0, -1).join('.')
      }

      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          formData.append(key, payload[key])
        }
      }

      await context.rootState.authAxios.post('/Documents/Upload', formData)
      // .then(() => {
      //   showSuccess('Add successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async updateDocument (context, payload) {
      const formData = new FormData()
      let isFirst = true

      for (const key in payload) {
        if (Object.prototype.hasOwnProperty.call(payload, key)) {
          if (isFirst) {
            isFirst = false
            continue
          }
          if (payload[key] !== null) {
            formData.append(key, payload[key])
          }
        }
      }

      await context.rootState.authAxios.put(`Documents/Update/${payload.id}`, formData)
      // .then(() => {
      //   showSuccess('Update successfully')
      // }).catch((error) => {
      //   if (error.response.data.error_message) {
      //     showError(error.response.data.error_message)
      //   } else {
      //     showError('Đã xảy ra lỗi không mong muốn')
      //   }
      // })
    },
    async deleteDocument (context, payload) {
      await context.rootState.authAxios.delete(`Documents/${payload}`
      ).then(() => {
        showSuccess('Xóa thành công')
      }).catch((error) => {
        if (error.response.data.error_message) {
          showError(error.response.data.error_message)
        } else {
          showError('Đã xảy ra lỗi không mong muốn')
        }
      })
    }
  }
}
